// extracted by mini-css-extract-plugin
export default {"section":"BurgerIngredients_section__UTPGs","tab__list":"BurgerIngredients_tab__list__y5MuP","article__container":"BurgerIngredients_article__container__oCf6v"};